import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { StationsListComponent } from '@app/components/profile/stations-list/stations-list.component';

@Component({
  selector: 'app-added-stations',
  standalone: true,
  imports: [StationsListComponent],
  templateUrl: './added-stations.component.html',
  styleUrl: './added-stations.component.scss',
})
export class AddedStationsComponent implements OnInit {
  userId = null;

  constructor(
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.route.parent.params.subscribe((params) => {
      this.userId = params['userId'];
    });
  }
}
